const decades = {
    '000': 'es',
    '00': 'as',
    '10': 'es',
    '20': 'as',
    '30': 'as',
    '40': 'es',
    '50': 'es',
    '60': 'as',
    '70': 'es',
    '80': 'as',
    '90': 'es'
}

const seasons = {
    0: 'tele',
    1: 'tele',
    2: 'tavasza',
    3: 'tavasza',
    4: 'tavasza',
    5: 'nyara',
    6: 'nyara',
    7: 'nyara',
    8: 'ősze',
    9: 'ősze',
    10: 'ősze',
    11: 'tele'

}

/**
 * @param date { Moment }
 */
const createDecadeFromDate = date => {
    const decade = Math.floor(date.year() / 10) * 10;
    const millennium = String(decade).slice(-3);
    const termination = millennium === '000' ? millennium : String(decade).slice(-2);
    return `${decade}-${decades[termination]} évek`;
}

/**
 * @param date { Moment }
 */
const createCenturyFromDate = date => {
    const year = date.year();
    const century = year > 0 ? Math.ceil(year / 100) : Math.floor(year / 100);
    return `${century}. század`;
}

/**
 * @param date { Moment }
 */
const createMillenniumFromDate = date => {
    const year = date.year();
    const century = year > 0 ? Math.ceil(year / 1000) : Math.floor(year / 1000);
    return `${century}. évezred`;
}

/**
 * @param date { Moment }
 */
const createSeasonFromDate = date => {
    const year = date.year();
    const season = seasons[date.month()];
    return `${year} ${season}`;
}

const addTimePrecision = timePrecisionModifier => {
    return timePrecisionModifier ? ` - (${timePrecisionModifier})` : '';
}


/**
 * @param date { Moment }
 * @param timePrecision { String|null}
 * @param timePrecisionModifier { String|null}
 * @returns { String }
 */
const createDateFromPrecision = (date, timePrecision, timePrecisionModifier) => {
    timePrecision = typeof timePrecision === 'string' ? timePrecision : '';
    switch (timePrecision.toLowerCase()) {
        case 'perc-pontos':
            return date.format("YYYY. MM. DD. h:mm");
        case 'óra-pontos':
            return date.format("YYYY. MM. DD. h");
        case 'nap-pontos':
            return date.format("YYYY. MM. DD.");
        case 'hét-pontos':
            return date.format("YYYY.") + " - " + date.week() + ". hét" + addTimePrecision(timePrecisionModifier);
        case 'hónap-pontos':
            return date.format("YYYY. MM.") + addTimePrecision(timePrecisionModifier);
        case 'év-pontos':
            return date.format("YYYY.") + addTimePrecision(timePrecisionModifier);
        case 'évtized-pontos':
            return createDecadeFromDate(date) + addTimePrecision(timePrecisionModifier);
        case 'évszázad-pontos':
            return createCenturyFromDate(date) + addTimePrecision(timePrecisionModifier);
        case 'évezred-pontos':
            return createMillenniumFromDate(date) + addTimePrecision(timePrecisionModifier);
        case 'évszak-pontos':
            return createSeasonFromDate(date) + addTimePrecision(timePrecisionModifier);
        default:
            return date.format("YYYY. MM. DD.");
    }
}

export {createDateFromPrecision}